import script from "./CHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CHeader.vue?vue&type=style&index=0&id=b293a5ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b293a5ae"]])

export default __exports__